let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g9cy2")).then(() => parcelRequire('fBWiu'));